import React, { useState, useEffect, useContext } from "react";
import APICall from "../../services/apiCall";
import SoftBadge from "../common/SoftBadge";
import APIPortalTable from "../common/Table/APIPortalTable";
import AppContext from "../../context/Context";
import { toast } from "react-toastify";

const PracticeLocationHistoryModal = ({ masterCustIdForPracticeLocationHistory, appid }) => {
  const [practiceLocationHistoryData, setPracticeLocationHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { loginUserDetails, accessToken } = useContext(AppContext);

  useEffect(() => {
    setLoading(true);
    let params = {
      master_customer_id: masterCustIdForPracticeLocationHistory,
      app_id: appid,
    };
    APICall.servertrip("GET", "practice_location__history", loginUserDetails, params).then(
      (res) => {
        let practiceLocationdata = res.data.items.map((data, index) => {
          data["id"] = index;
          return data;
        });
        setPracticeLocationHistoryData(practiceLocationdata);
        setLoading(false);
      },
      (error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        toast.error(resMessage);
        setLoading(false);
      }
    );
  }, []);

  const accessFormatter = ({ cell, row }) => {
    return (
      <>
        {cell.getValue().toString() === "OFF" ? (
          <SoftBadge pill bg="danger" className="me-2">
            OFF
          </SoftBadge>
        ) : (
          <SoftBadge pill bg="success" className="me-2">
            ON
          </SoftBadge>
        )}
      </>
    );
  };

  const columns = [
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "master_customer_id",
      header: "Master Customer ID",
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "practice_id",
      header: "Practice ID",
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "cust_id",
      header: "Customer ID",
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "practice_cust_id",
      header: "Practice Cust. ID",
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "billing_location",
      header: "Billing location",
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "access",
      header: "Location Access",
      Cell: accessFormatter,
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "comment",
      header: "Comment",
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "updated_date",
      header: "Updated Date",
    },
  ];

  return (
    <>
      <APIPortalTable
        data={practiceLocationHistoryData}
        columns={columns}
        loading={loading}
        enablePagination
        CSVFileName={"Practice location history data.csv"}
      />
    </>
  );
};

export default PracticeLocationHistoryModal;
